import {$} from '../jquery-definition.js';

$( function() {
	updateParallaxPosition();
	document.addEventListener( 'scroll', updateParallaxPosition );
	document.addEventListener( 'resize', updateParallaxPosition );
} );

function updateParallaxPosition() {
	if ( $( window ).width() > 991 && !isTouchDevice() ) {
		var pageHeight = window.innerHeight;
		var pageYOffset = window.pageYOffset;
		var pageCenter = pageYOffset + pageHeight / 2;

		var elements = document.getElementsByClassName( 'parallax' );
		for ( var i = 0; i < elements.length; i++ ) {
			var element = elements[ i ];
			var clientRect = element.getBoundingClientRect();
			var center = pageYOffset + clientRect.top + clientRect.height / 2;
			var offset = (center - pageCenter) / (pageHeight / 2);

			var parallaxShiftInPixel = element.getAttribute( 'data-parallax-shift' );
			if ( !parallaxShiftInPixel ) {
				parallaxShiftInPixel = 40;
			}

			element.style.transform = 'translateY(' + Math.round( offset * parallaxShiftInPixel ) + 'px)';
		}
	} else {
		var elements = document.getElementsByClassName( 'parallax-' + i );
		for ( var j = 0; j < elements.length; j++ ) {
			element.style.transform = 'translateY(0px)';
		}
	}
}

function isTouchDevice() {
	return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}
